import { useRef } from 'react';

type SoundKey = 'success' | 'error' | 'warning' | 'notification';

type SoundFormat = 'mp3' | 'wav';

interface UseSoundPlayerOptions {
  format?: SoundFormat; // default: 'mp3'
  volume?: number; // 0.0 to 1.0, default: 1.0
}

const defaultFormat: SoundFormat = 'mp3';

export function useSoundPlayer(options?: UseSoundPlayerOptions) {
  const format = options?.format ?? defaultFormat;
  const volume = options?.volume ?? 1.0;

  const soundMap: Record<SoundKey, string> = {
    success: `/sounds/success.${format}`,
    error: `/sounds/error.${format}`,
    warning: `/sounds/warning.${format}`,
    notification: `/sounds/notification.${format}`,
  };

  const audioCache = useRef<Record<SoundKey, HTMLAudioElement>>({} as any);

  const playSound = (type: SoundKey) => {

    try {
        const soundUrl = soundMap[type];

        if (!soundUrl) {
        console.warn(`No sound URL defined for type: ${type}`);
        return;
        }

        if (!audioCache.current[type]) {
        const audio = new Audio(soundUrl);
        audio.volume = volume;
        audioCache.current[type] = audio;
        }

        const audio = audioCache.current[type];
        audio.currentTime = 0; // rewind to start
        audio.play().catch((err) => {
        console.error(`Error playing sound '${type}':`, err);
        });
    } catch (error) {
        console.error(`Error playing sound '${type}':`, error);
    }
  };

    return playSound;
}
